<script setup lang="ts">
import { defineAsyncComponent, computed, withDefaults } from 'vue'

interface PropTypes {
  logoAltText?: string
  logoUrl?: string
  layout?: string
  menuItems?: Array<string>
}

const props = withDefaults(defineProps<PropTypes>(), {
  logoAltText: 'Near Earth Autonomy Co. Logo',
  logoUrl: null,
  layout: 'HeaderLayout',
  menuItems: null,
})

const layout = computed(() => defineAsyncComponent(() => import(`Common/components/layouts/${props.layout}.vue`)))
</script>

<template>
  <component :is="layout">
    <template v-if="props.logoUrl" #header-logo>
      <img :src="props.logoUrl" :alt="logoAltText" />
    </template>
    <template v-if="menuItems" #main-nav></template>
    <template #header-actions>
      <slot name="header-actions"></slot>
    </template>
  </component>
</template>
